export const EVENT_ACTIONS = {
  CLEAR_EVENT: 'CLEAR_EVENT',
  SAVE_CHILD_EVENTS: 'SAVE_CHILD_EVENTS',
  SAVE_CHILDREN_EVENTS: 'SAVE_CHILDREN_EVENTS',
};
